// === Social-Media Footer-Icons: In neuem Tab öffnen ===
(function () {
  function openSocialLinksInNewTab() {
    document.querySelectorAll('.list-social__link').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openSocialLinksInNewTab);
  } else {
    openSocialLinksInNewTab();
  }
})();
